'use client';

// Root error boundary for the App Router. Next.js renders this in place of the
// root layout when an error bubbles all the way up (e.g. a client render crash
// like a component dereferencing undefined). Without it, such errors are swallowed
// by Next's default error UI and NEVER reach Sentry — which is exactly why recent
// editor white-screens produced zero Sentry events. Reporting here closes that gap.
import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="sl">
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 16,
          fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
          color: '#1a1a1a',
          background: '#fafafa',
          padding: 24,
          textAlign: 'center',
        }}
      >
        <h1 style={{ fontSize: 22, margin: 0 }}>Prišlo je do napake</h1>
        <p style={{ margin: 0, color: '#555', maxWidth: 420 }}>
          Nekaj je šlo narobe. Poskusite znova ali osvežite stran.
        </p>
        <button
          type="button"
          onClick={() => reset()}
          style={{
            padding: '10px 20px',
            fontSize: 15,
            borderRadius: 8,
            border: 'none',
            background: '#1a1a1a',
            color: '#fff',
            cursor: 'pointer',
          }}
        >
          Poskusi znova
        </button>
      </body>
    </html>
  );
}
